import { ClientEvents } from "discord.js";
import { IPlugin, PluginCommandOptions, PluginEventOptions } from "../typings/plugins";

export class Plugin implements IPlugin {
    constructor(options: IPlugin) {
        Object.assign(this, options);
    }

    name: string;
    description: string;
    enabled?: boolean;
    version: `v${number}.${number}.${number}`;
    events?: {
        [name in keyof ClientEvents]: PluginEventOptions<name>
    };
    commands?: PluginCommandOptions | undefined;
    
}